import { useEffect, useState } from "react";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Send, RefreshCw } from "lucide-react";
import {
  reminderApi,
  buildBirthdayMessage,
  buildChristmasMessage,
  waLink,
} from "@/lib/agenda";

export const FelicitacionDialog = ({ open, target, kind, onClose }) => {
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const generate = async () => {
    if (!target) return;
    setLoading(true);
    try {
      const phrase = await reminderApi.phrase(kind === "navidad" ? "navidad" : "cumpleanos");
      const text =
        kind === "navidad"
          ? buildChristmasMessage(target, phrase)
          : buildBirthdayMessage(target, phrase);
      setMessage(text);
    } catch (e) {
      toast.error("Algo no ha ido bien. Prueba otra vez o vuelve más tarde.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && target) generate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, target?.phone, kind]);

  if (!target) return null;

  const title = kind === "navidad" ? "Felicitación de Navidad" : "Felicitación de cumpleaños";

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-[480px] rounded-3xl" data-testid="felicitacion-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl text-slate-900">{title}</DialogTitle>
          <DialogDescription className="text-sm text-slate-500">
            La frase la prepara la IA. Revísala, edítala o pide otra antes de enviar a {target.name}.
          </DialogDescription>
        </DialogHeader>

        <Textarea
          value={loading ? "Preparando el mensaje..." : message}
          onChange={(e) => setMessage(e.target.value)}
          rows={6}
          disabled={loading}
          className="text-sm leading-relaxed"
          data-testid="felicitacion-message-text"
        />

        <div className="flex items-center justify-between gap-2 pt-1">
          <Button
            type="button"
            variant="outline"
            onClick={generate}
            disabled={loading}
            className="rounded-full gap-1.5"
            data-testid="felicitacion-regenerate"
          >
            <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
            Otra frase
          </Button>
          <a
            href={waLink(target.phone, message)}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            data-testid="felicitacion-send"
            className="inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-white text-sm font-medium"
            style={{ backgroundColor: "#275FBE" }}
          >
            <Send className="h-4 w-4" />
            Enviar por WhatsApp
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
